var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHyperbeenLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2504.51 424.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: #6d6f70;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 353.83,
    y1: 129.63,
    x2: 590.69,
    y2: 129.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b4893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#26458f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#453e87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#513c84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 902.66,
    y1: 129.03,
    x2: 1091.71,
    y2: 129.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8652d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f77ae0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 902.66,
    y1: 226.4,
    x2: 1091.56,
    y2: 226.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2473e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2381dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#20b2d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#1fd1cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1fddca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 902.66,
    y1: 31.65,
    x2: 1091.56,
    y2: 31.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bb2c98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#f45f6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa646a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.5.42v97.38h107.54V.42h69.59v257.22h-69.59v-97.38h-107.54v97.38H3.91V.42h69.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.68,169.45v88.19h-69.59V.42h151.82c66.1,0,93.31,33.07,93.31,84.52s-27.21,84.52-93.31,84.52h-82.24ZM754.74,106.98c15.19,0,23.73-8.08,23.73-22.05s-8.54-22.05-23.73-22.05h-79.07v44.1h79.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.42,257.64V.42h151.82c66.11,0,93.31,20.95,93.31,72.39,0,35.28-17.08,59.16-47.44,65.4,29.41,6.62,45.87,29.03,45.87,63.58v55.85h-72.75v-67.98c0-13.23-8.55-20.21-23.73-20.21h-77.49v88.19h-69.59ZM1306.09,106.98c15.18,0,23.71-8.08,23.71-22.05s-8.54-22.05-23.71-22.05h-79.07v44.1h79.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1669.56,65.46c0,27.92-11.71,47.77-31,57.69,25.94,8.08,40.49,29.76,40.49,62.1,0,45.94-28.15,72.39-77.49,72.39h-166.06V.42h156.56c49.35,0,77.5,23.52,77.5,65.04ZM1596.81,84.93c0-14.7-7.91-22.05-23.73-22.05h-68v42.26h70.53c13.6-.37,21.2-6.61,21.2-20.21ZM1606.29,173.12c0-13.23-8.54-20.57-23.71-20.21h-77.49v42.26h77.49c15.18,0,23.71-8.08,23.71-22.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1945.34.42v62.47h-154.98v34.91h132.84v62.47h-132.84v34.91h154.98v62.47h-224.57V.42h224.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2213.85.42v62.47h-154.98v34.91h132.84v62.47h-132.84v34.91h154.98v62.47h-224.57V.42h224.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2333.71.42l101.21,163.15V.42h69.58v257.22h-75.91l-101.21-163.15v163.15h-69.59V.42h75.92Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,407.52l7.17-8.49c10.68,9.66,20.92,14.48,35.11,14.48s22.82-7.31,22.82-17.41v-.29c0-9.51-5.12-14.92-26.62-19.46-23.55-5.12-34.38-12.73-34.38-29.55v-.29c0-16.09,14.19-27.94,33.65-27.94,14.92,0,25.6,4.24,35.99,12.58l-6.73,8.92c-9.51-7.75-19.02-11.12-29.55-11.12-13.31,0-21.8,7.31-21.8,16.53v.29c0,9.66,5.27,15.07,27.79,19.9,22.82,4.97,33.35,13.31,33.35,28.96v.29c0,17.55-14.63,28.96-34.96,28.96-16.24,0-29.55-5.41-41.84-16.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M300.04,371.53v-.29c0-28.23,21.21-52.96,52.37-52.96s52.08,24.43,52.08,52.66v.29c0,28.23-21.21,52.96-52.37,52.96s-52.08-24.43-52.08-52.66ZM392.5,371.53v-.29c0-23.26-16.97-42.28-40.38-42.28s-40.08,18.72-40.08,41.98v.29c0,23.26,16.97,42.28,40.38,42.28s40.08-18.72,40.08-41.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M633.15,320.04h11.56v91.72h57.64v10.68h-69.19v-102.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M923.39,379.58v-59.54h11.56v58.81c0,22.09,11.85,34.52,31.31,34.52s30.87-11.41,30.87-33.79v-59.54h11.56v58.66c0,29.84-17.12,45.35-42.71,45.35s-42.57-15.51-42.57-44.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1267.32,330.72h-34.38v-10.68h80.46v10.68h-34.38v91.72h-11.7v-91.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1540.3,320.04h11.56v102.4h-11.56v-102.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1781.53,371.53v-.29c0-28.23,21.21-52.96,52.37-52.96s52.08,24.43,52.08,52.66v.29c0,28.23-21.21,52.96-52.37,52.96s-52.08-24.43-52.08-52.66ZM1873.99,371.53v-.29c0-23.26-16.97-42.28-40.38-42.28s-40.08,18.72-40.08,41.98v.29c0,23.26,16.97,42.28,40.38,42.28s40.08-18.72,40.08-41.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2114.64,320.04h10.83l64.51,82.07v-82.07h11.26v102.4h-9.22l-66.12-83.97v83.97h-11.26v-102.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2427.7,407.52l7.17-8.49c10.68,9.66,20.92,14.48,35.11,14.48s22.82-7.31,22.82-17.41v-.29c0-9.51-5.12-14.92-26.62-19.46-23.55-5.12-34.38-12.73-34.38-29.55v-.29c0-16.09,14.19-27.94,33.65-27.94,14.92,0,25.6,4.24,35.99,12.58l-6.73,8.92c-9.51-7.75-19.02-11.12-29.55-11.12-13.31,0-21.8,7.31-21.8,16.53v.29c0,9.66,5.27,15.07,27.79,19.9,22.82,4.97,33.35,13.31,33.35,28.96v.29c0,17.55-14.63,28.96-34.96,28.96-16.24,0-29.55-5.41-41.84-16.38Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "440.32 259.25 353.83 259.25 507.5 0 593.98 0 440.32 259.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.51 165.88 280.01 .42 366.05 .42 438.94 102.92 400.51 165.88"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 902.66,
    y: 97.79,
    width: 189.05,
    height: 62.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 902.66,
    y: 195.17,
    width: 188.91,
    height: 62.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 902.66,
    y: 0.42,
    width: 188.91,
    height: 62.47
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperbeenLogo);
export default __webpack_public_path__ + "static/media/hyperbeen-logo.9c4fd04bb75fa785c30661f598784b2c.svg";
export { ForwardRef as ReactComponent };